// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__HAy8n","disabled":"checkbox_disabled__5geEV","active":"checkbox_active__5Wtib","green":"checkbox_green__9Vp2w","black":"checkbox_black__hBePO"};